import React, {memo, useEffect} from "react";
import Root from "./root";
import axios from "axios";
import {actionGetDataProfileUser, actionLogOutUser} from "../redux/actions/user/user";
import {useDispatch, useSelector} from "react-redux";
import {handleOpenModalSurvey} from "../redux/actions/modals/modalSurvey";
import {handelOpenModalFinalizeRegistration} from "../redux/actions/modals/modalFinalizeRegistration";
import {setBaseAddressForUser} from "../redux/actions/user/guest";
import {
    BAE_API_GOOGLE_MAP, BASE_URL, GEOCODE_GOOGLE_MAP,
    KEY_GOOGLE_MAP, LANGUAGE_GOOGLE_MAP, USERS_CHECK_LOGIN_POST
} from "../apis";
import qs from "querystring";
// import ChatWidget from "./root/partials/chatWidget";

// import sendEvent from "./googleanalytics";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import ReactGA from 'react-ga';

const App = () => {
    
    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig = {
      apiKey: "AIzaSyAgy2nPfOUmg4F66mFci6IQBLXTXL71jes",
      authDomain: "fruitmruit-react.firebaseapp.com",
      projectId: "fruitmruit-react",
      storageBucket: "fruitmruit-react.appspot.com",
      messagingSenderId: "428138156893",
      appId: "1:428138156893:web:c3389d908d4c0ed88e4eb4",
      measurementId: "G-WKMCCESXCR"
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);

    const trackingId = "G-09LDW9507B"; // Replace with your Google Analytics tracking ID
    ReactGA.initialize(trackingId);

    const {eventName, params} = useSelector(state => state.googleAnalytics);
    // console.log("changed");
    // console.log(params);
    if(eventName !== '') {
        logEvent(analytics, eventName, params);
    }




    




    const dispatch = useDispatch();
    const {token} = useSelector(state => state.user);
    const {address: guestAddress} = useSelector(state => state.guest);

    useEffect(() => {
        /*اجرای متد بررسی لاگین بودن کاربر*/
        handleCheckedLoginUserAndGetDataUser();

        // eslint-disable-next-line
    }, [token]);

    /*بررسی لاگین بودن کاربر*/
    const handleCheckedLoginUserAndGetDataUser = async () => {
        try {
            const postData = localStorage.getItem('najva_user_token') !== null ? qs.stringify({device_token: localStorage.getItem('najva_user_token'), os: 'react'}) : {};
            const response = await axios.post(BASE_URL + USERS_CHECK_LOGIN_POST, postData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                }
            });
            const {info, status, poll_time} = response.data;
            if (status === 'ok') {
                /*مودال نظر سنجی*/
                if (poll_time) {
                    dispatch(handleOpenModalSurvey(true, poll_time.id));
                }
                /*ثبت اطلاعات کاربر*/
                // dispatch(actionGetDataProfileUser(info));
                dispatch(actionGetDataProfileUser({
                        ...info, ...{
                            average_rank: response.data.rank.average_rank,
                            count_rank: response.data.rank.count_rank,
                            rank: response.data.rank.rank,
                            return_period: response.data.rank.return_period,
                            total_score: response.data.rank.total_score
                        }
                    }));

                /*دریافت مشخصات کاربر*/
                const {fullname: i_fullname, glat: i_glat, glng: i_glng} = info;

                /*بررسی ریجیستر بودن کاربر*/
                if (!i_fullname || !i_glat || !i_glng) {
                    /*باز کردن مودال ریجیستر*/
                    dispatch(handelOpenModalFinalizeRegistration());
                }
            } else if (status === 're_login') {
                /*اجرای متد ساخت کاربر مهمان*/
                createDateUserGuest();
                /*خروج کاربر از سایت*/
                dispatch(actionLogOutUser());
            }
        } catch (e) {
            console.log(e);
        }
    }

    /*ساخت کاربر مهمان*/
    const createDateUserGuest = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const {latitude, longitude} = position.coords;
                if (guestAddress.lng !== longitude || guestAddress.lat !== latitude) {
                    getTextAddressInApiGoogle(latitude, longitude);
                }
            }, (e) => {
                console.log(e);
            });
        }
    };

    /*دریافت متن آدرس کاربر با api google از روی مختصات*/
    const getTextAddressInApiGoogle = (longitude, latitude) => {
        /*Get Text Address In Google Map*/
        axios({
            method: 'post',
            url: BAE_API_GOOGLE_MAP + GEOCODE_GOOGLE_MAP + longitude + ',' + latitude + KEY_GOOGLE_MAP + LANGUAGE_GOOGLE_MAP,
            headers: {
                'Accept': 'application/json',
            },
        }).then((response) => {
            if (response.data.results[0]) {
                successGetLngLatAndSetState(longitude, latitude, response.data.status, response.data.results[0].formatted_address);
            }
        });
    };

    /*ثبت مختصات دریافتی کاربر*/
    const successGetLngLatAndSetState = (longitude, latitude, status, textAddress) => {
        if (status === 'OK') {
            dispatch(setBaseAddressForUser(longitude, latitude, textAddress));
        } else {
            if (guestAddress.textAddress !== 'آدرسی یافت نشد.')
                dispatch(setBaseAddressForUser(0, 0, 'آدرسی یافت نشد.'));
        }
    };

    return (
        <div id={'app'} className={'rtl'}>
            {/*<ChatWidget />*/}
            <Root/>
        </div>
    )
}

export default memo(App);
